import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import './TrackOrder.css';

export default function TrackOrder() {

    const [searchParams] = useSearchParams();

    const [search, setSearch] = useState('');
    const [orderStatus, setOrderStatus] = useState("");

    const handletrack = async (code) => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_URL}/api/trackOrder`,
                { search: code }
            );
            console.log(res.data.status);

            setOrderStatus(res.data.status);

        } catch (error) {
            console.error('Error fetching order status:', error);
        }
    };

    useEffect(() => {
        const codeFromURL = searchParams.get("search");

        if (codeFromURL) {
            setSearch(codeFromURL);      // fill input
            handletrack(codeFromURL);   // auto fetch
        }
    }, [searchParams]);

    return (
        <div className='track-order-container'>
            <h2>Track Your Order</h2>

            <input
                type="text"
                placeholder="Enter Order Code"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            <button onClick={() => handletrack(search)}>
                Track
            </button>

            <p>Order Status: <span style={{color: 'green',fontWeight: '500', marginLeft:'10px'}}>{orderStatus}</span></p>
        </div>
    );
}